import React from 'react';
import PropTypes from 'prop-types';
import FollowButton from './follow-button';
import Loading from '../../shared/loading';
import defaultOnErrorHandler from '../../shared/default-on-error-handler';
import { followContributor, unfollowContributor } from '../../services/contributor-service';
import { recordProfileStatistic } from '../../services/statistics-service';
import useSynchronizedFollowStatus from './follow-button/profile-follow-state-listener';

export default function ProfileFollowButton({
  exp,
  isProfileFollowedByCurrentUser,
  profileId,
  lessUnfollow,
  onUnfollow,
  isOnWireSide,
  followEventName,
  unfollowEventName,
}) {
  const [followed, setFollowed] = React.useState(isProfileFollowedByCurrentUser);
  const loadingRef = React.createRef();
  const name = isOnWireSide ? 'profile-follow-button-on-sidebar' : 'profile-follow-button';
  const broadcast = useSynchronizedFollowStatus({ id: profileId, onStatusChanged: setFollowed });

  const toggle = () => {
    loadingRef.current.start({
      onFadeInComplete: () => {
        const apiCall = followed ? unfollowContributor : followContributor;
        apiCall(profileId, exp).then(() => {
          loadingRef.current.stop();
          recordProfileStatistic(profileId, followed ? unfollowEventName : followEventName);
          broadcast(!followed);
          followed && onUnfollow && onUnfollow();
        }).catch(err => {
          loadingRef.current.stop();
          defaultOnErrorHandler(err, `Error ${followed ? 'un' : ''}following this contributor`);
        });
      },
    });
  };

  return (
    <Loading ref={loadingRef} variant="button">
      <FollowButton {...{ name, lessUnfollow, followed }} onToggle={toggle} />
    </Loading>
  );
}

ProfileFollowButton.propTypes = {
  exp: PropTypes.string,
  isProfileFollowedByCurrentUser: PropTypes.bool.isRequired,
  profileId: PropTypes.number.isRequired,
  lessUnfollow: PropTypes.bool,
  onUnfollow: PropTypes.func,
  isOnWireSide: PropTypes.bool,
  followEventName: PropTypes.string,
  unfollowEventName: PropTypes.string,
};

ProfileFollowButton.defaultProps = {
  exp: null,
  lessUnfollow: false,
  onUnfollow: null,
  isOnWireSide: false,
  followEventName: 'follow_profile',
  unfollowEventName: 'unfollow_profile',
};
